import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import debateMindLogo from '../assets/debate-mind-ai.png';
import '../styles/Create_Account.css';

const Create_Account = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        first_name: '',
        last_name: '',
        username: '',
        password: ''
    });
    const [errorMsg, setErrorMsg] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg('');
        setIsSubmitting(true);

        try {
            //const response = await fetch("http://192.168.1.10:8000/api/talk-show-web-register/", {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API}/talk-show-web-register/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Registration failed");
            }

            // Show success popup instead of navigating immediately
            setShowSuccessPopup(true);

        } catch (error) {
            setErrorMsg(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handlePopupClose = () => {
        setShowSuccessPopup(false);
        navigate("/user-login");
    };

    return (
        <div className="form-wrapper">
            <div className="form-header">
                <img src={debateMindLogo} className="logo" alt="Debate Mind Logo" />
            </div>

            <h2 style={{ textAlign: 'center' }}>Create User Account</h2>

            {errorMsg && <div className="error-message">{errorMsg}</div>}

            <form className="signup-form" onSubmit={handleSubmit}>
                <label>Email Address<span style={{ color: "red" }}>*</span></label>
                <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />

                <label>Name<span style={{ color: "red" }}>*</span></label>
                <div className="name-group">
                    <input
                        type="text"
                        name="first_name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={handleChange}
                        required
                    />
                </div>

                <label>Username<span style={{ color: "red" }}>*</span></label>
                <input
                    type="text"
                    name="username"
                    placeholder="Create Username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                />

                <label>Password<span style={{ color: "red" }}>*</span></label>
                <input
                    type="password"
                    name="password"
                    placeholder="Create Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                />

                <button
                    type="submit"
                    className="submit-button"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Creating Account...' : 'Create Account'}
                </button>

                <p className="login-link" style={{ textAlign: 'center' }}>
                    Already have an account?{" "}
                    <Link to="/user-login">
                        <span className="signin-text">Sign In</span>
                    </Link>
                </p>

            </form>

            {/* Success Popup */}
            {showSuccessPopup && (
                <div className="popup-overlay">
                    <div className="success-popup">
                        <h3>Account Created Successfully!</h3>
                        <p>Your account has been created. You can now log in with your credentials.</p>
                        <button onClick={handlePopupClose}>Continue to Login</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Create_Account;